import {
  Button,
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Typography,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import productApi from '../../api/product.api'
import promotionApi from '../../api/promotion.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/promotion.module.scss'

const { Text } = Typography

const CouponCreatePage = () => {
  const { couponId } = useParams()
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [editCoupon, setEditCoupon] = useState({})
  const [formValues, setFormValues] = useState({
    couponScoreType: 'PERCENT',
  })
  const [couponTitleCnt, setCouponTitleCnt] = useState(0)
  const [couponBodyCnt, setCouponBodyCnt] = useState(0)
  const [codeValid, setCodeValid] = useState(0)
  const [selectedOptions, setSelectedOptions] = useState({
    benefitType: 0, // 쿠폰 유형
    benefitKind: 'event', // 쿠폰 종류
    issuanceType: true, // 발급 유형
    dateType: '1week', // 다운로드 기간 > 날짜 유형 선택
    expirationPeriod: 'period', // 유효 기간 설정 종류
    couponBody: false, // 추가 설명 없음
    couponUpSaleOption: false, // 최소 구매 금액 설정
    discountMaximumCondition: false, // 할인 최대 금액
    quantity: false, // 수량 한정
    couponType: 'TOTAL', // 쿠폰 적용 대상
  })
  const [exposureDate, setExposureDate] = useState({
    startDate: dayjs().startOf('day'),
    endDate: dayjs().add(1, 'weeks').endOf('day'),
  })
  const [expirationDate, setExpirationDate] = useState({
    startDate: dayjs().startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [searchOptions, setSearchOptions] = useState({
    productName: '',
    brandName: '',
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedProductRowKeys, setSelectedProductRowKeys] = useState([])
  const [selectedProductRows, setSelectedProductRows] = useState([])
  const [selectedRelatedProductRowKeys, setSelectedRelatedProductRowKeys] =
    useState([])
  const [selectedRelatedProductRows, setSelectedRelatedProductRows] = useState(
    [],
  )
  const [productList, setProductList] = useState([])
  const [relatedProductList, setRelatedProductList] = useState([])
  const [brandList, setBrandList] = useState([])
  const [selectedTargetList, setSelectedTargetList] = useState([])

  const benefitTypeItems = [
    { label: '쿠폰', value: 0 },
    { label: '적립금', value: 1, disabled: true },
  ]
  const benefitKindItems = [
    { label: '이벤트', value: 'event' },
    { label: '연관상품', value: 'related_product', disabled: true },
    { label: '리뷰', value: 'review', disabled: true },
    { label: '첫구매', value: 'first_purchase', disabled: true },
    { label: '재구매', value: 'repurchase', disabled: true },
    { label: '모든 회원', value: 'all_member', disabled: true },
    { label: '생일', value: 'birthday', disabled: true },
  ]
  const issuanceTypeItems = [
    { label: '자동', value: true },
    { label: '수동', value: false },
  ]
  const dateItems = [
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
    { label: '1년', value: '1year' },
    { label: '무제한', value: 'unlimited' },
  ]
  const expirationPeriodItems = [
    { label: '기간으로 설정', value: 'period' },
    { label: '발급일 기준으로 설정', value: 'issue_date' },
    { label: '무제한', value: 'unlimited' },
  ]
  const scoreTypeItems = [
    { scoreType: 'PERCENT', scoreText: '%' },
    { scoreType: 'WON', scoreText: '원' },
  ]
  const couponTypeItems = [
    { label: '전체', value: 'TOTAL' },
    { label: '브랜드', value: 'BRAND' },
    { label: '상품', value: 'PRODUCT' },
  ]

  const disabledStartDate = (current) => {
    if (couponId) {
      return false
    } else {
      return current.isBefore(dayjs())
    }
  }

  const disabledExposureEndDate = (current) => {
    if (couponId) {
      return false
    } else {
      return current.isBefore(exposureDate.startDate)
    }
  }

  const disabledExpirationEndDate = (current) => {
    if (couponId) {
      return false
    } else {
      return current.isBefore(exposureDate.startDate)
    }
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
      setSelectedRows(selectedRows)
    },
  }
  const selectedRowSelection = {
    selectedRowKeys: selectedProductRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedProductRowKeys(selectedRowKeys)
      setSelectedProductRows(selectedRows)
    },
  }
  const selectedRelatedProductRowSelection = {
    selectedRowKeys: selectedRelatedProductRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRelatedProductRowKeys(selectedRowKeys)
      setSelectedRelatedProductRows(selectedRows)
    },
  }
  const productColumns = [
    {
      title: '상품번호',
      width: 80,
      dataIndex: 'productId',
      key: 'productId',
      fixed: 'left',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: '브랜드명',
      // width: 120,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      // width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '상품 상태',
      // width: 100,
      dataIndex: 'isPurchase',
      key: 'isPurchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity < 1) {
          return <span>품절</span>
        } else if (value) {
          return <span>판매중</span>
        } else {
          return <span>미판매</span>
        }
      },
    },
    {
      title: '재고수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '판매가',
      // width: 90,
      dataIndex: 'price1',
      key: 'price1',
      ellipsis: true,
      // sorter: (a, b) => {}
      render: (value) => `${value?.toLocaleString() ?? 0}원`,
    },
    {
      title: '할인가',
      // width: 90,
      dataIndex: 'price2',
      key: 'price2',
      ellipsis: true,
      // sorter: (a, b) => {}
      render: (value) => `${value?.toLocaleString() ?? 0}원`,
    },
  ]
  const relatedMainProductColumns = [
    {
      title: '상품번호',
      width: 80,
      dataIndex: 'main_product_id',
      key: 'main_product_id',
      fixed: 'left',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: '브랜드명',
      // width: 120,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      // width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '상품 상태',
      // width: 100,
      dataIndex: 'is_purchase',
      key: 'is_purchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>
        } else if (value) {
          return <span>판매중</span>
        } else {
          return <span>미판매</span>
        }
      },
    },
    {
      title: '재고수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '판매가',
      // width: 90,
      dataIndex: 'price_1',
      key: 'price_1',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '할인가',
      // width: 90,
      dataIndex: 'price_2',
      key: 'price_2',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ]
  const relatedProductColumns = [
    {
      title: '연관상품번호',
      // width: 100,
      dataIndex: 'related_product_id',
      key: 'related_product_id',
      fixed: 'left',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: '브랜드명',
      // width: 120,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      // width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '상품 상태',
      // width: 100,
      dataIndex: 'is_purchase',
      key: 'is_purchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>
        } else if (value) {
          return <span>판매중</span>
        } else {
          return <span>미판매</span>
        }
      },
    },
    {
      title: '재고수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '판매가',
      // width: 90,
      dataIndex: 'price_1',
      key: 'price_1',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '할인가',
      // width: 90,
      dataIndex: 'price_2',
      key: 'price_2',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '주요상품번호',
      // width: 100,
      dataIndex: 'main_product_id',
      key: 'main_product_id',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ]
  const brandColumns = [
    {
      title: '브랜드명',
      // width: 90,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '회사명',
      // width: 90,
      dataIndex: 'sellerName',
      key: 'sellerName',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '대표자명',
      // width: 90,
      dataIndex: 'representative',
      key: 'representative',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ]
  const mainAndRelatedProductColumns = [
    {
      title: '연관상품번호',
      width: 100,
      dataIndex: 'related_product_id',
      key: 'related_product_id',
      fixed: 'left',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: '브랜드명',
      // width: 120,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      // width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '상품 상태',
      // width: 100,
      dataIndex: 'isPurchase',
      key: 'isPurchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity < 1) {
          return <span>품절</span>
        } else if (value) {
          return <span>판매중</span>
        } else {
          return <span>미판매</span>
        }
      },
    },
    {
      title: '재고수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '판매가',
      // width: 90,
      dataIndex: 'price1',
      key: 'price1',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '할인가',
      // width: 90,
      dataIndex: 'price2',
      key: 'price2',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '주요상품번호',
      // width: 100,
      dataIndex: 'main_product_id',
      key: 'main_product_id',
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: '주요상품브랜드명',
      // width: 120,
      dataIndex: 'main_brandName',
      key: 'main_brandName',
      ellipsis: true,
    },
    {
      title: '주요상품명',
      // width: 150,
      dataIndex: 'main_productName',
      key: 'main_productName',
      ellipsis: true,
    },
  ]

  useEffect(() => {
    if (couponId) {
      getCouponInfo()
    } else {
      setEditCoupon({})
      setFormValues({ couponScoreType: 'PERCENT' })
      setCouponTitleCnt(0)
      setCouponBodyCnt(0)
      setCodeValid(0)
      setSelectedOptions({
        benefitType: 0, // 쿠폰 유형
        benefitKind: 'event', // 쿠폰 종류
        issuanceType: true, // 발급 유형
        dateType: '1week', // 다운로드 기간 > 날짜 유형 선택
        expirationPeriod: 'period', // 유효 기간 설정 종류
        couponBody: false, // 추가 설명 없음
        couponUpSaleOption: false, // 최소 구매 금액 설정
        discountMaximumCondition: false, // 할인 최대 금액
        quantity: false, // 수량 한정
        couponType:
          user && user.role && user.role === 'super_admin' ? 'TOTAL' : 'BRAND', // 쿠폰 적용 대상
      })
      setExposureDate({
        startDate: dayjs().startOf('day'),
        endDate: dayjs().add(1, 'weeks').endOf('day'),
      })
      setExpirationDate({
        startDate: dayjs().startOf('day'),
        endDate: dayjs().endOf('day'),
      })
      setSearchOptions({
        productName: '',
        brandName: '',
      })
      setSelectedRows([])
      setSelectedRowKeys([])
      setSelectedProductRows([])
      setSelectedProductRowKeys([])
      setSelectedRelatedProductRows([])
      setSelectedRelatedProductRowKeys([])
      setSelectedTargetList([])
    }
  }, [couponId])

  useEffect(() => {
    if (selectedOptions.couponType === 'BRAND') {
      getBrandList()
    } else {
      getProductList()
    }
  }, [
    selectedOptions.benefitKind,
    selectedOptions.couponType,
    selectedTargetList,
  ])

  // useEffect(() => {
  //   if (
  //     selectedOptions.benefitKind === 'related_product' &&
  //     selectedOptions.couponType === 'product'
  //   ) {
  //     getRelatedProductList();
  //   }
  // }, [selectedRows])

  /**
   * coupon 수정 시, 기존 정보 가져오기
   */
  const getCouponInfo = async () => {
    setIsLoading(true)
    try {
      const param = {
        couponId: couponId,
      }
      const res = await promotionApi.readCouponById(param, user.id)
      if (res.data.code === 200) {
        let resultBrandList = []
        let resultProductList = []
        if (res.data.result.coupon.couponType === 'BRAND') {
          resultBrandList = await getBrandList('initial')
        } else if (
          res.data.result.coupon.couponType === 'PRODUCT'
          // || res.data.result.coupon.couponType === "related_product"
        ) {
          resultProductList = await getProductList('initial')
        }
        setFormValueFromEdit(
          res.data.result,
          resultBrandList,
          resultProductList,
        )
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('couponInfo read error', error)
    }
  }

  /**
   * 상품 List 가져오기
   */
  const getProductList = async (type = '', idList = []) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          productName: '',
          brandName: '',
          idList:
            selectedOptions.benefitKind === 'related_product'
              ? selectedTargetList
                  .map((target) => target.main_product_id)
                  .join(',')
              : selectedTargetList.map((target) => target.productId).join(','),
        }
      } else if (type === 'edit_item') {
        param = {
          ...searchOptions,
          idList: idList.join(','),
        }
      } else {
        param = {
          ...searchOptions,
          idList:
            selectedOptions.benefitKind === 'related_product'
              ? selectedTargetList
                  .map((target) => target.main_product_id)
                  .join(',')
              : selectedTargetList.map((target) => target.productId).join(','),
        }
      }
      const res = await productApi.readProductListNotIncluded(param, user.id)
      if (res.data.code === 200) {
        setProductList(res.data.result)
        setIsLoading(false)
        return res.data.result
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('getProductList read error', error)
    }
  }

  /**
   * 연관 상품 List 가져오기
   */
  // const getRelatedProductList = async () => {
  // 	setIsLoading(true);
  // 	try {
  // 		let param;
  // 		let mainProductIdList = [];
  // 		let relatedProductIdList = [];
  // 		for (const target of selectedTargetList) {
  // 			mainProductIdList.push(target.main_product_id);
  // 			relatedProductIdList.push(target.related_product_id);
  // 		}
  // 		if (selectedRows?.length === 0) {
  // 			param = {
  // 				main_product_id: 0,
  // 				coupon_id: match.params.hasOwnProperty("id")
  // 					? editCoupon.coupon_id
  // 					: null,
  // 				relatedProductIdList: relatedProductIdList,
  // 				mainProductIdList: mainProductIdList,
  // 			};
  // 		} else {
  // 			param = {
  // 				main_product_id: selectedRows.find(
  // 					(row) => row.id === selectedRowKeys[0]
  // 				).main_product_id,
  // 				coupon_id: match.params.hasOwnProperty("id")
  // 					? editCoupon.coupon_id
  // 					: null,
  // 				relatedProductIdList: relatedProductIdList,
  // 				mainProductIdList: mainProductIdList,
  // 			};
  // 		}
  // 		const res = await productApi.readRelatedProductListWithoutIdList(param);
  // 		if (res.code === 200) {
  // 			setRelatedProductList(res.result);
  // 		} else {
  // 			alert(
  // 				"해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다."
  // 			);
  // 		}
  // 		setIsLoading(false);
  // 	} catch (error) {
  // 		setIsLoading(false);
  // 		setError(error);
  // 		console.log("getRelatedProductList read error", error);
  // 	}
  // };

  /**
   * brand List 가져오기
   */
  const getBrandList = async (type = '', idList = []) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          brandName: '',
          idList: selectedTargetList.map((target) => target.id).join(','),
        }
      } else if (type === 'edit_item') {
        param = {
          brandName: searchOptions.brandName,
          idList: idList.join(','),
        }
      } else {
        param = {
          brandName: searchOptions.brandName,
          idList: selectedTargetList.map((target) => target.id).join(','),
        }
      }
      const res = await productApi.readBrandListNotIncluded(param, user.id)
      if (res.data.code === 200) {
        setBrandList(res.data.result)
        setIsLoading(false)
        return res.data.result
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('getBrandList read error', error)
    }
  }

  /**
   * Coupon code valid
   */
  const codeValidation = async (code) => {
    setIsLoading(true)
    try {
      const param = {
        code: code,
      }
      const res = await promotionApi.couponCodeValidation(param, user.id)
      if (res.data.code === 200) {
        if (res.data.result) {
          setCodeValid(2)
        } else {
          setCodeValid(1)
        }
      } else {
        setCodeValid(1)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('codeValidation valid error', error)
    }
  }

  /**
   * 수정할 coupon 정보 form에 setting
   */
  const setFormValueFromEdit = (
    couponInfo,
    resultBrandList,
    resultProductList,
  ) => {
    let editCouponInfo = {}
    let settingFormValue = {}
    let settingSelectedOption = {}
    let editList = []
    let settingSelectedTargetList = []
    for (const key in couponInfo.coupon) {
      if (key === 'couponBody') {
        // 추가설명
        if (couponInfo.coupon[key] === null || couponInfo.coupon[key] === '') {
          settingSelectedOption[key] = true
          setCouponBodyCnt(0)
        } else {
          settingSelectedOption[key] = false
          setCouponBodyCnt(couponInfo.coupon[key]?.length)
        }
        settingFormValue[key] = couponInfo.coupon[key]
      } else if (key === 'couponExpirationTo') {
        // 사용 가능 기간설정
        if (
          couponInfo.coupon[key] === null &&
          couponInfo.coupon['couponPeriodDays'] === null
        ) {
          settingSelectedOption['expirationPeriod'] = 'unlimited'
        } else if (couponInfo.coupon[key] !== null) {
          settingSelectedOption['expirationPeriod'] = 'period'
          setExpirationDate({
            ...expirationDate,
            startDate: dayjs(couponInfo.coupon['couponFrom']),
            endDate: dayjs(couponInfo.coupon[key]),
          })
        } else if (couponInfo.coupon['couponPeriodDays'] !== null) {
          settingSelectedOption['expirationPeriod'] = 'issue_date'
          settingFormValue['couponPeriodDays'] =
            couponInfo.coupon['couponPeriodDays']
        }
      } else if (key === 'couponTo') {
        // 다운로드 기간
        const startDate = dayjs(couponInfo.coupon['couponFrom'])
        if (couponInfo.coupon[key]) {
          const endDate = dayjs(couponInfo.coupon[key])
          let diffDays = endDate.diff(startDate, 'days')
          if (diffDays === 7) {
            settingSelectedOption['dateType'] = '1week'
          } else {
            if (
              dayjs(couponInfo.coupon['couponFrom'])
                .add(1, 'months')
                .isSame(endDate, 'day')
            ) {
              settingSelectedOption['dateType'] = '1month'
            } else if (
              dayjs(couponInfo.coupon['couponFrom'])
                .add(3, 'months')
                .isSame(endDate, 'day')
            ) {
              settingSelectedOption['dateType'] = '3month'
            } else if (
              dayjs(couponInfo.coupon['couponFrom'])
                .add(6, 'months')
                .isSame(endDate, 'day')
            ) {
              settingSelectedOption['dateType'] = '6month'
            } else if (
              dayjs(couponInfo.coupon['couponFrom'])
                .add(1, 'years')
                .isSame(endDate, 'day')
            ) {
              settingSelectedOption['dateType'] = '1year'
            } else {
              settingSelectedOption['dateType'] = ''
            }
          }
        } else {
          settingSelectedOption['dateType'] = 'unlimited'
        }
        setExposureDate({
          ...exposureDate,
          startDate: dayjs(couponInfo.coupon['couponFrom']),
          endDate: couponInfo.coupon[key]
            ? dayjs(couponInfo.coupon[key])
            : couponInfo.coupon[key],
        })
      } else if (key === 'couponCode') {
        // 발급유형
        if (couponInfo.coupon[key]) {
          settingFormValue[key] = couponInfo.coupon[key]
          setCodeValid(2)
        }
        settingSelectedOption['issuanceType'] = !couponInfo.coupon[key]
      } else if (key === 'couponMaximumScore') {
        // 할인 최대 금액
        if (couponInfo.coupon[key] === null) {
          settingSelectedOption['discountMaximumCondition'] = true
        } else {
          settingSelectedOption['discountMaximumCondition'] = false
          settingFormValue[key] = couponInfo.coupon[key]
        }
      } else if (key === 'couponPublishNumber') {
        // 수량 한정
        if (couponInfo.coupon[key] === 9999999) {
          settingSelectedOption['quantity'] = true
        } else {
          settingSelectedOption['quantity'] = false
          settingFormValue[key] = couponInfo.coupon[key]
        }
      } else if (key === 'couponTitle') {
        settingFormValue[key] = couponInfo.coupon[key]
        setCouponTitleCnt(couponInfo.coupon[key]?.length)
      } else if (key === 'couponType') {
        // 쿠폰 종류 및 쿠폰 적용 대상
        switch (couponInfo.coupon[key]) {
          case 'ALL':
            // case 'event':
            settingSelectedOption['benefitKind'] = 'event'
            settingSelectedOption[key] = 'TOTAL'
            break
          case 'CATEGORY':
            settingSelectedOption['benefitKind'] = 'event'
            settingSelectedOption[key] = couponInfo.coupon[key]
            break
          case 'BRAND':
            settingSelectedOption['benefitKind'] = 'event'
            settingSelectedOption[key] = couponInfo.coupon[key]
            editList = resultBrandList.filter((brand) => {
              if (couponInfo.relatedIdList.includes(brand.id)) {
                settingSelectedTargetList.push(brand)
                return false
              } else {
                return true
              }
            })
            setBrandList(editList)
            break
          case 'PRODUCT':
            settingSelectedOption['benefitKind'] = 'event'
            settingSelectedOption[key] = couponInfo.coupon[key]
            editList = resultProductList.filter((product) => {
              if (couponInfo.relatedIdList.includes(product.productId)) {
                settingSelectedTargetList.push(product)
                return false
              } else {
                return true
              }
            })
            setProductList(editList)
            break
          // case 'related_product':
          //   settingSelectedOption['benefitKind'] = 'related_product'
          //   settingSelectedOption[key] = 'PRODUCT'
          //   settingSelectedTargetList = couponInfo.relatedProductList
          //   break
        }
      } else if (key === 'couponUpSaleOption') {
        // 최소 구매 금액 설정
        if (couponInfo.coupon[key] === null) {
          settingSelectedOption[key] = true
        } else {
          settingSelectedOption[key] = false
          settingFormValue[key] = couponInfo.coupon[key]
        }
      } else if (key === 'couponScore' || key === 'couponScoreType') {
        // formValue에만 저장
        settingFormValue[key] = couponInfo.coupon[key]
      } else if (
        key === 'couponId' ||
        key === 'id' ||
        key === 'coupon_available_number' ||
        key === 'couponIsAvailable' ||
        key === 'couponPublishAvailable' ||
        // key === 'coupon_usage_number' ||
        key === 'createdAt' ||
        key === 'createdBy'
      ) {
        // editCouponInfo에 저장
        editCouponInfo[key] = couponInfo.coupon[key]
      }
    }
    setSelectedOptions({ ...selectedOptions, ...settingSelectedOption })
    setFormValues({ ...formValues, ...settingFormValue })
    setEditCoupon(editCouponInfo)
    setSelectedTargetList(settingSelectedTargetList)
  }

  /**
   * radio select options handleChange
   */
  const handleSelectOptions = (e) => {
    const { name, value } = e.target
    if (name === 'couponType') {
      setSearchOptions({
        productName: '',
        brandName: '',
      })
      setSelectedRowKeys([])
      setSelectedRows([])
      setSelectedProductRowKeys([])
      setSelectedProductRows([])
      setSelectedOptions({ ...selectedOptions, [name]: value })
      setSelectedTargetList([])
      setFormValues({ ...formValues, [name]: value })
    } else if (name === 'benefitKind') {
      if (value === 'related_product') {
        setSelectedOptions({
          ...selectedOptions,
          [name]: value,
          couponType: 'PRODUCT',
        })
      } else {
        setSelectedOptions({ ...selectedOptions, [name]: value })
      }
    } else if (name === 'dateType') {
      const startDate = exposureDate.startDate.format('YYYY-MM-DD')
      if (value === '1week') {
        setExposureDate({
          ...exposureDate,
          endDate: dayjs(startDate).add(1, 'weeks').endOf('day'),
        })
      } else if (value === '1month') {
        setExposureDate({
          ...exposureDate,
          endDate: dayjs(startDate).add(1, 'months').endOf('day'),
        })
      } else if (value === '3month') {
        setExposureDate({
          ...exposureDate,
          endDate: dayjs(startDate).add(3, 'months').endOf('day'),
        })
      } else if (value === '6month') {
        setExposureDate({
          ...exposureDate,
          endDate: dayjs(startDate).add(6, 'months').endOf('day'),
        })
      } else if (value === '1year') {
        setExposureDate({
          ...exposureDate,
          endDate: dayjs(startDate).add(1, 'years').endOf('day'),
        })
      } else if (value === 'unlimited') {
        setExposureDate({ ...exposureDate, endDate: null })
      }
      setSelectedOptions({ ...selectedOptions, [name]: value })
    } else if (name === 'expirationPeriod') {
      switch (value) {
        case 'period':
          setExpirationDate({
            ...expirationDate,
            startDate: exposureDate.startDate,
            endDate: exposureDate.endDate,
          })
          setFormValues({ ...formValues, couponPeriodDays: null })
          break
        case 'issue_date':
          setFormValues({ ...formValues, couponExpirationTo: null })
          break
        case 'unlimited':
          setFormValues({
            ...formValues,
            couponPeriodDays: null,
            couponExpirationTo: null,
          })
          break
      }
      setSelectedOptions({ ...selectedOptions, [name]: value })
    } else if (name === 'issuanceType') {
      if (value) {
        setCodeValid(0)
        setFormValues({ ...formValues, couponCode: null })
      }
      setSelectedOptions({ ...selectedOptions, [name]: value })
    } else if (name === 'couponBody') {
      if (e.target.checked) {
        setFormValues({ ...formValues, [name]: null })
        setCouponBodyCnt(0)
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked })
    } else if (name === 'couponUpSaleOption') {
      if (e.target.checked) {
        setFormValues({ ...formValues, [name]: null })
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked })
    } else if (name === 'discountMaximumCondition') {
      if (e.target.checked) {
        setFormValues({ ...formValues, couponMaximumScore: null })
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked })
    } else if (name === 'quantity') {
      if (e.target.checked) {
        setFormValues({ ...formValues, couponPublishNumber: null })
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked })
    } else {
      setSelectedOptions({ ...selectedOptions, [name]: value })
    }
  }

  /**
   * 검색어 입력
   */
  const onSearchProduct = () => {
    setSelectedRows([])
    setSelectedRowKeys([])
    setSelectedProductRows([])
    setSelectedProductRowKeys([])
    if (selectedOptions.couponType === 'BRAND') {
      getBrandList()
    } else {
      getProductList()
    }
  }

  /**
   * 초기화
   */
  const handleResetSearch = () => {
    setSelectedRows([])
    setSelectedRowKeys([])
    setSelectedProductRows([])
    setSelectedProductRowKeys([])
    setSearchOptions({
      productName: '',
      brandName: '',
    })
    if (selectedOptions.couponType === 'BRAND') {
      getBrandList('initial')
    } else {
      getProductList('initial')
    }
  }

  /**
   * 선택 항목 등록
   */
  const handleSelectedRowRegister = () => {
    if (selectedOptions.benefitKind === 'related_product') {
      const newSelectedList = [
        ...selectedTargetList,
        ...selectedRelatedProductRows,
      ]
      setSelectedTargetList(newSelectedList)
      setSelectedRelatedProductRows([])
      setSelectedRelatedProductRowKeys([])
      setSelectedProductRows([])
      setSelectedProductRowKeys([])
      setSelectedRows([])
      setSelectedRowKeys([])
    } else {
      const newSelectedList = [...selectedTargetList, ...selectedRows]
      setSelectedTargetList(newSelectedList)
      setSelectedRows([])
      setSelectedRowKeys([])
      if (selectedOptions.couponType === 'BRAND') {
        getBrandList(
          'edit_item',
          newSelectedList.map((selectedItem) => selectedItem.id),
        )
      } else {
        getProductList(
          'edit_item',
          newSelectedList.map((selectedItem) => selectedItem.productId),
        )
      }
    }
  }

  /**
   * 선택 항목 취소
   */
  const handleSelectedRowCancel = () => {
    if (selectedOptions.benefitKind === 'related_product') {
      const exceptedTargetList = selectedTargetList.filter(
        (target) => !selectedProductRowKeys.includes(target.id),
      )
      setSelectedTargetList(exceptedTargetList)
      setSelectedProductRows([])
      setSelectedProductRowKeys([])
      getProductList('edit_item', [])
    } else {
      let exceptedTargetList = []
      if (selectedOptions.couponType === 'BRAND') {
        exceptedTargetList = selectedTargetList.filter(
          (target) => !selectedProductRowKeys.includes(target.id),
        )
      } else {
        exceptedTargetList = selectedTargetList.filter(
          (target) => !selectedProductRowKeys.includes(target.productId),
        )
      }
      setSelectedTargetList(exceptedTargetList)
      setSelectedProductRows([])
      setSelectedProductRowKeys([])
      if (selectedOptions.couponType === 'BRAND') {
        getBrandList(
          'edit_item',
          exceptedTargetList.map((selectedItem) => selectedItem.id),
        )
      } else {
        getProductList(
          'edit_item',
          exceptedTargetList.map((selectedItem) => selectedItem.productId),
        )
      }
    }
  }

  const handleRowEvent = (record) => {
    return {
      onClick: () => {
        if (selectedOptions.benefitKind === 'related_product') {
          if (selectedRowKeys.includes(record.id)) {
            setSelectedRowKeys([])
            setSelectedRows([])
          } else {
            setSelectedRowKeys([record.id])
            setSelectedRows([record])
          }
        } else {
          if (selectedOptions.couponType === 'BRAND') {
            if (selectedRowKeys.includes(record.id)) {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.id),
              )
              setSelectedRows(
                selectedRows.filter((row) => row.id !== record.id),
              )
            } else {
              setSelectedRowKeys([...selectedRowKeys, record.id])
              setSelectedRows([...selectedRows, record])
            }
          } else {
            if (selectedRowKeys.includes(record.productId)) {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.productId),
              )
              setSelectedRows(
                selectedRows.filter(
                  (row) => row.productId !== record.productId,
                ),
              )
            } else {
              setSelectedRowKeys([...selectedRowKeys, record.productId])
              setSelectedRows([...selectedRows, record])
            }
          }
        }
      },
    }
  }

  const handleProductRowEvent = (record) => {
    return {
      onClick: () => {
        if (selectedOptions.benefitKind === 'related_product') {
          if (selectedProductRowKeys.includes(record.id)) {
            setSelectedProductRowKeys(
              selectedProductRowKeys.filter((key) => key !== record.id),
            )
            setSelectedProductRows(
              selectedProductRows.filter((row) => row.id !== record.id),
            )
          } else {
            setSelectedProductRowKeys([...selectedProductRowKeys, record.id])
            setSelectedProductRows([...selectedProductRows, record])
          }
        } else {
          if (selectedOptions.couponType === 'BRAND') {
            if (selectedProductRowKeys.includes(record.id)) {
              setSelectedProductRowKeys(
                selectedProductRowKeys.filter((key) => key !== record.id),
              )
              setSelectedProductRows(
                selectedProductRows.filter((row) => row.id !== record.id),
              )
            } else {
              setSelectedProductRowKeys([...selectedProductRowKeys, record.id])
              setSelectedProductRows([...selectedProductRows, record])
            }
          } else {
            if (selectedProductRowKeys.includes(record.productId)) {
              setSelectedProductRowKeys(
                selectedProductRowKeys.filter(
                  (key) => key !== record.productId,
                ),
              )
              setSelectedProductRows(
                selectedProductRows.filter(
                  (row) => row.productId !== record.productId,
                ),
              )
            } else {
              setSelectedProductRowKeys([
                ...selectedProductRowKeys,
                record.productId,
              ])
              setSelectedProductRows([...selectedProductRows, record])
            }
          }
        }
      },
    }
  }

  const handleRelatedProductRowEvent = (record) => {
    return {
      onClick: () => {
        if (selectedRelatedProductRowKeys.includes(record.related_product_id)) {
          setSelectedRelatedProductRowKeys(
            selectedRelatedProductRowKeys.filter(
              (key) => key !== record.related_product_id,
            ),
          )
          setSelectedRelatedProductRows(
            selectedRelatedProductRows.filter(
              (row) => row.related_product_id !== record.related_product_id,
            ),
          )
        } else {
          setSelectedRelatedProductRowKeys([
            ...selectedRelatedProductRowKeys,
            record.related_product_id,
          ])
          setSelectedRelatedProductRows([...selectedRelatedProductRows, record])
        }
      },
    }
  }

  /**
   * input value change handler
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === 'couponTitle') {
      setFormValues({ ...formValues, [name]: value })
      setCouponTitleCnt(value?.length)
    } else if (name === 'couponBody') {
      setFormValues({ ...formValues, [name]: value })
      setCouponBodyCnt(value?.length)
    } else if (name === 'couponCode') {
      if (value?.length === 0) {
        setCodeValid(0)
      } else {
        codeValidation(value)
      }
      setFormValues({ ...formValues, [name]: value })
    } else if (name === 'productName' || name === 'brandName') {
      setSearchOptions({ ...searchOptions, [name]: value })
    } else if (name === 'couponScore') {
      if (formValues?.couponScoreType === 'PERCENT') {
        let scoreValue = value
        if (scoreValue > 100) {
          setFormValues({ ...formValues, [name]: 100 })
        } else {
          setFormValues({ ...formValues, [name]: scoreValue })
        }
      } else {
        setFormValues({ ...formValues, [name]: value })
      }
    } else {
      setFormValues({ ...formValues, [name]: value })
    }
  }

  useEffect(() => {
    if (formValues?.couponScoreType === 'PERCENT') {
      let scoreValue = formValues?.couponScore
      if (scoreValue > 100) {
        setFormValues({ ...formValues, couponScore: 100 })
      }
    }
  }, [formValues])

  const handleCancel = () => {
    if (
      window.confirm('작성 중이던 내용이 있습니다. 그래도 취소하시겠습니까?')
    ) {
      navigate('/coupon/list')
    }
  }

  const handleFinish = async () => {
    setIsLoading(true)
    try {
      const result = formValuesValidation()
      if (result) {
        let res
        let couponMasterDTO = {}
        let newEditCoupon = {
          ...formValues,
          couponFrom: exposureDate.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          couponTo: exposureDate.endDate?.format('YYYY-MM-DD HH:mm:ss'),
        }
        for (const key in selectedOptions) {
          if (key === 'expirationPeriod') {
            if (selectedOptions[key] === 'unlimited') {
              newEditCoupon['couponExpirationTo'] = null
              newEditCoupon['couponPeriodDays'] = null
            } else if (selectedOptions[key] === 'period') {
              newEditCoupon['couponExpirationTo'] =
                expirationDate.endDate?.format('YYYY-MM-DD HH:mm:ss')
            }
          } else if (key === 'quantity') {
            if (selectedOptions[key]) {
              newEditCoupon['couponPublishNumber'] = 9999999
            }
          } else if (key === 'couponType') {
            if (
              selectedOptions.benefitKind === 'event' &&
              selectedOptions[key] === 'TOTAL'
            ) {
              newEditCoupon[key] = 'ALL'
            } else if (selectedOptions.benefitKind === 'related_product') {
              newEditCoupon[key] = selectedOptions.benefitKind
              couponMasterDTO['relatedIdList'] = selectedTargetList.map(
                (target) => target.related_product_id,
              )
              couponMasterDTO['relatedProductList'] = selectedTargetList
            } else if (selectedOptions[key] === 'CATEGORY') {
              newEditCoupon[key] = selectedOptions[key]
              couponMasterDTO['relatedCategoryIdList'] = selectedTargetList.map(
                (target) => target.categoryId,
              )
            } else if (selectedOptions[key] === 'BRAND') {
              newEditCoupon[key] = selectedOptions[key]
              couponMasterDTO['relatedIdList'] = selectedTargetList.map(
                (target) => target.id,
              )
            } else if (selectedOptions[key] === 'PRODUCT') {
              newEditCoupon[key] = selectedOptions[key]
              couponMasterDTO['relatedIdList'] = selectedTargetList.map(
                (target) => target.productId,
              )
            } else {
              newEditCoupon[key] = selectedOptions[key]
            }
          }
        }
        if (couponId) {
          couponMasterDTO['editKey'] = 'all'
          couponMasterDTO['coupon'] = {
            ...newEditCoupon,
            ...editCoupon,
            createdAt: dayjs(editCoupon?.createdAt).format(
              'YYYY-MM-DD HH:mm:ss',
            ),
          }
          res = await promotionApi.editCoupon(couponMasterDTO, user.id)
        } else {
          newEditCoupon['couponIsAvailable'] = true
          newEditCoupon['couponPublishAvailable'] = true
          // newEditCoupon['coupon_available_number'] = 1
          couponMasterDTO['coupon'] = newEditCoupon
          res = await promotionApi.createCoupon(couponMasterDTO, user.id)
        }
        if (res.data.code === 200) {
          alert('해당 내용이 성공적으로 반영되었습니다.')
          navigate(`/coupon/list`)
        } else if (res.data.code === 999) {
          alert(res.data.msg)
        } else {
          alert(
            `쿠폰을 ${
              couponId ? '수정' : '등록'
            }하는데 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.`,
          )
        }
        setIsLoading(false)
      } else {
        throw 'not valid'
      }
    } catch (error) {
      setIsLoading(false)
      console.log('handleFinish coupon register error', error)
    }
  }

  const formValuesValidation = () => {
    try {
      for (const key in selectedOptions) {
        switch (key) {
          case 'issuanceType':
            if (!selectedOptions.issuanceType) {
              if (
                !Object.prototype.hasOwnProperty.call(
                  formValues,
                  'couponCode',
                ) ||
                formValues.couponCode === null ||
                codeValid !== 2
              ) {
                throw `발급 유형을 [수동]으로 선택하셨습니다. 코드 값을 입력하지 않으셨거나 이미 존재하는 코드 값입니다.`
              }
            }
            break
          case 'expirationPeriod':
            if (selectedOptions[key] === 'issue_date') {
              if (
                !Object.prototype.hasOwnProperty.call(
                  formValues,
                  'couponPeriodDays',
                ) ||
                formValues.couponPeriodDays === null
              ) {
                throw `사용 가능 기간을 발급일 기준으로 선택하셨습니다. 유효일수를 입력하거나 무제한을 선택해주시길 바랍니다.`
              }
            }
            break
          case 'couponBody':
            if (!selectedOptions[key]) {
              if (
                !Object.prototype.hasOwnProperty.call(formValues, key) ||
                formValues[key] === null ||
                formValues[key]?.length === 0
              ) {
                throw `추가 설명 입력란이 비어있습니다. 적을 내용이 없다면 '없음'으로 체크해주시길 바랍니다.`
              }
            }
            break
          case 'couponUpSaleOption':
            if (!selectedOptions[key]) {
              if (
                !Object.prototype.hasOwnProperty.call(formValues, key) ||
                formValues[key] === null ||
                formValues[key] === 0
              ) {
                throw `최소 구매 금액 설정의 입력란이 비어있습니다. 적을 내용이 없다면 '조건 없음'으로 체크해주시길 바랍니다.`
              }
            }
            break
          case 'discountMaximumCondition':
            if (!selectedOptions[key]) {
              if (
                !Object.prototype.hasOwnProperty.call(
                  formValues,
                  'couponMaximumScore',
                ) ||
                formValues['couponMaximumScore'] === null ||
                formValues['couponMaximumScore'] === 0
              ) {
                throw `할인 최대 금액의 입력란이 비어있습니다. 적을 내용이 없다면 '무제한'으로 체크해주시길 바랍니다.`
              }
            }
            break
          case 'quantity':
            if (!selectedOptions[key]) {
              if (
                !Object.prototype.hasOwnProperty.call(
                  formValues,
                  'couponPublishNumber',
                ) ||
                formValues['couponPublishNumber'] === null ||
                formValues['couponPublishNumber'] === 0
              ) {
                throw `수량 한정의 입력란이 비어있습니다. 적을 내용이 없다면 '무제한'으로 체크해주시길 바랍니다.`
              }
            }
            break
        }
      }
      if (formValues.couponTitle === null || formValues.couponTitle === '') {
        throw `쿠폰명을 입력하지 않았습니다.`
      } else if (
        formValues.couponScore === null ||
        formValues.couponScore === 0
      ) {
        throw `할인설정 항목에 값이 비어있습니다.`
      } else if (
        selectedOptions.couponType !== 'TOTAL' &&
        selectedTargetList?.length === 0
      ) {
        throw `쿠폰을 적용할 대상이 없습니다.`
      }
      return true
    } catch (error) {
      setIsLoading(false)
      console.log('formValuesValidation validation error', error)
      alert(error)
      return false
    }
  }

  const [exampleShow, setExampleShow] = useState(false)
  const [exampleTitle, setExampleTitle] = useState({
    id: '',
    title: '',
  })

  return (
    <>
      {/* 예시 모달 */}
      <Modal
        className="related-product-modal-wrap"
        width={'40%'}
        title={exampleTitle.title}
        open={exampleShow}
        onCancel={() => setExampleShow(!exampleShow)}
        footer={null}
      >
        <img
          alt={exampleTitle.title}
          src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}.png`}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Modal>
      <ContentHeader title={`쿠폰 ${couponId ? '수정' : '등록'}`} />
      <div className={`${styles['coupon-register-wrap']}`}>
        <Row
          align={'middle'}
          wrap={false}
          style={{
            borderBottom: 'solid 1px #ced4da',
            paddingBottom: '0.5rem',
            marginBottom: '1rem',
          }}
        >
          <span style={{ fontSize: '1.3em' }}>쿠폰 등록</span>
          <span
            // className="product-register-box-subtitle"
            style={{
              fontSize: '0.9rem',
              cursor: 'pointer',
              marginLeft: '10px',
              color: '#117ffa',
              borderBottom: 'solid 1px #117ffa',
            }}
            id={'tag'}
            onClick={() => {
              setExampleShow(true)
              setExampleTitle({
                id: 'coupon',
                title: '쿠폰 예시',
              })
            }}
          >
            예시
          </span>
        </Row>
        <Form.Item
          // className="center-label"
          label="쿠폰 유형"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            name="benefitType"
            options={benefitTypeItems}
            onChange={handleSelectOptions}
            value={selectedOptions.benefitType}
            disabled={couponId}
          />
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="쿠폰 종류"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            name="benefitKind"
            options={benefitKindItems}
            onChange={handleSelectOptions}
            value={selectedOptions.benefitKind}
            disabled={couponId}
          />
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="발급 유형"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Radio.Group
              name="issuanceType"
              options={issuanceTypeItems}
              onChange={handleSelectOptions}
              value={selectedOptions.issuanceType}
              disabled={couponId}
            />
            <Input
              name="couponCode"
              placeholder="코드 값 입력"
              value={formValues.couponCode}
              onChange={handleInputChange}
              disabled={selectedOptions.issuanceType || couponId}
              style={{ width: 200 }}
            />
            {codeValid === 1 && (
              <Text type="danger" style={{ marginLeft: 8, fontSize: 12 }}>
                이미 존재하는 코드입니다.
              </Text>
            )}
            {codeValid === 2 && (
              <Text type="success" style={{ marginLeft: 8, fontSize: 12 }}>
                사용할 수 있는 코드입니다.
              </Text>
            )}
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="쿠폰명"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className={`${styles['text-input-wrap']}`}
              name="couponTitle"
              placeholder="쿠폰명을 입력해주세요."
              maxLength={18}
              value={formValues.couponTitle}
              onChange={handleInputChange}
              required
            />
            <div className={`${styles['count-text']}`}>{couponTitleCnt}/18</div>
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          label="다운로드 기간"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <ConfigProvider theme={CustomDateButtonRadioTheme}>
            <Radio.Group
              className={`${styles['date-type-select-wrap']} ${styles['options-list']}`}
              name="dateType"
              options={dateItems}
              onChange={handleSelectOptions}
              value={selectedOptions.dateType}
              optionType="button"
            />
            <Row align="middle">
              <DatePicker
                className={`${styles['date-input-wrap']}`}
                format="YYYY-MM-DD"
                value={exposureDate.startDate}
                disabledDate={disabledStartDate}
                allowClear={false}
                onChange={(value) => {
                  setSelectedOptions({ ...selectedOptions, dateType: '' })
                  setExposureDate({
                    ...exposureDate,
                    startDate: value.startOf('day'),
                  })
                  setExpirationDate({
                    ...expirationDate,
                    startDate: value.startOf('day'),
                    endDate: value.endOf('day'),
                  })
                }}
                onOk={() =>
                  setSelectedOptions({ ...selectedOptions, dateType: '' })
                }
              />
              <div style={{ margin: '0 10px' }}>~</div>
              <DatePicker
                className={`${styles['date-input-wrap']}`}
                format="YYYY-MM-DD"
                value={exposureDate.endDate}
                disabledDate={disabledExposureEndDate}
                allowClear={false}
                onChange={(value) => {
                  setSelectedOptions({ ...selectedOptions, dateType: '' })
                  setExposureDate({ ...exposureDate, endDate: value })
                  setExpirationDate({ ...expirationDate, endDate: value })
                }}
                onOk={() =>
                  setSelectedOptions({ ...selectedOptions, dateType: '' })
                }
              />
            </Row>
          </ConfigProvider>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          label="사용 가능 기간"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            className={`${styles['date-type-select-wrap']}`}
            name="expirationPeriod"
            options={expirationPeriodItems}
            onChange={handleSelectOptions}
            value={selectedOptions.expirationPeriod}
          />
          {selectedOptions.expirationPeriod === 'period' && (
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align="middle">
                <DatePicker
                  className={`${styles['date-input-wrap']}`}
                  format="YYYY-MM-DD"
                  value={expirationDate.startDate}
                  disabledDate={disabledStartDate}
                  disabled
                  onChange={(value) => {
                    setSelectedOptions({ ...selectedOptions, dateType: '' })
                    setExpirationDate({ ...expirationDate, startDate: value })
                  }}
                  onOk={() =>
                    setSelectedOptions({ ...selectedOptions, dateType: '' })
                  }
                />
                <div style={{ margin: '0 10px' }}>~</div>
                <DatePicker
                  className={`${styles['date-input-wrap']}`}
                  format="YYYY-MM-DD"
                  value={expirationDate.endDate}
                  disabledDate={disabledExpirationEndDate}
                  allowClear={false}
                  onChange={(value) => {
                    setSelectedOptions({ ...selectedOptions, dateType: '' })
                    setExpirationDate({ ...expirationDate, endDate: value })
                  }}
                  onOk={() =>
                    setSelectedOptions({ ...selectedOptions, dateType: '' })
                  }
                />
              </Row>
            </ConfigProvider>
          )}

          {selectedOptions.expirationPeriod === 'issue_date' && (
            <Row align="middle">
              <div
                className={`${styles.subtext}`}
                style={{ marginLeft: 0, marginRight: 10 }}
              >
                발급일로부터
              </div>
              <Input
                name="couponPeriodDays"
                value={formValues.couponPeriodDays}
                onChange={handleInputChange}
                style={{ width: 150 }}
              />
              <div className={`${styles.subtext}`}>일 간 유효</div>
            </Row>
          )}
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="추가 설명"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              name="couponBody"
              placeholder="설명을 입력해주세요"
              maxLength={20}
              disabled={selectedOptions.couponBody}
              value={formValues.couponBody}
              onChange={handleInputChange}
              style={{ width: 300 }}
            />
            <div className={`${styles['count-text']}`}>{couponBodyCnt}/20</div>
            <Checkbox
              name="couponBody"
              checked={selectedOptions.couponBody}
              onChange={handleSelectOptions}
            >
              없음
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="최소 구매 금액 설정"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className={`${styles['coupon-register-form-input-number']}`}
              type="number"
              name="couponUpSaleOption"
              value={formValues.couponUpSaleOption}
              disabled={selectedOptions.couponUpSaleOption}
              min={0}
              addonAfter={<span>원</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: 'right' }}
            />
            <div className={`${styles.subtext}`}>이상 구매 시</div>
            <Checkbox
              name="couponUpSaleOption"
              checked={selectedOptions.couponUpSaleOption}
              onChange={handleSelectOptions}
            >
              조건 없음
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="할인설정"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Input
            className={`${styles['coupon-register-form-input-number']}`}
            type="number"
            name="couponScore"
            value={formValues.couponScore}
            onChange={handleInputChange}
            min={0}
            required
            addonAfter={
              <Select
                style={{ textAlign: 'left' }}
                value={formValues.couponScoreType}
                onChange={(value) =>
                  setFormValues({ ...formValues, couponScoreType: value })
                }
              >
                {scoreTypeItems.map((item, idx) => (
                  <Select.Option
                    key={`score_type_${idx}`}
                    value={item.scoreType}
                  >
                    {item.scoreText}
                  </Select.Option>
                ))}
              </Select>
            }
            style={{ width: 170, textAlign: 'right' }}
          />
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="할인 최대 금액"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <div
              className={`${styles.subtext}`}
              style={{ marginLeft: 0, marginRight: 6 }}
            >
              최대
            </div>
            <Input
              className={`${styles['coupon-register-form-input-number']}`}
              type="number"
              name="couponMaximumScore"
              value={formValues.couponMaximumScore}
              disabled={selectedOptions.discountMaximumCondition}
              min={0}
              addonAfter={<span>원</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: 'right', marginRight: 0 }}
            />
            <div className={`${styles.subtext}`}>할인</div>
            <Checkbox
              name="discountMaximumCondition"
              checked={selectedOptions.discountMaximumCondition}
              onChange={handleSelectOptions}
            >
              무제한
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          // className="center-label"
          label="수량 한정"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className={`${styles['coupon-register-form-input-number']}`}
              type="number"
              name="couponPublishNumber"
              value={formValues.couponPublishNumber}
              disabled={selectedOptions.quantity}
              min={0}
              addonAfter={<span>개</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: 'right' }}
            />
            <Checkbox
              name="quantity"
              checked={selectedOptions.quantity}
              onChange={handleSelectOptions}
            >
              무제한
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider
          className={`${styles['product-register-form-input-divider']}`}
        />
        <Form.Item
          label="쿠폰 적용 대상"
          colon={false}
          labelAlign={'left'}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          style={{ marginBottom: 0 }}
        >
          <Radio.Group
            name="couponType"
            onChange={handleSelectOptions}
            value={selectedOptions.couponType}
            disabled={couponId}
          >
            {couponTypeItems.map((couponType, idx) => {
              if (couponType.value === 'PRODUCT') {
                return (
                  <Radio key={`couponType_${idx}`} value={couponType.value}>
                    {couponType.label}
                  </Radio>
                )
              } else {
                return (
                  <Radio
                    key={`couponType_${idx}`}
                    value={couponType.value}
                    disabled={
                      selectedOptions.benefitKind === 'related_product' ||
                      (couponType.value === 'TOTAL' &&
                        !(user && user.role && user.role === 'super_admin'))
                    }
                  >
                    {couponType.label}
                  </Radio>
                )
              }
            })}
          </Radio.Group>
        </Form.Item>
        {selectedOptions.benefitKind === 'related_product' &&
        selectedOptions.couponType === 'PRODUCT' ? (
          <>
            <div
              className={`${styles['coupon-target-border-wrap']}`}
              style={{ borderBottom: 0, marginTop: 20 }}
            >
              <div className={`${styles['coupon-target-title']}`}>
                연관 상품 조회
              </div>
            </div>
            <div
              className={`${styles['coupon-target-border-wrap']}`}
              style={{ padding: '20px 25px' }}
            >
              <Row align="middle">
                {selectedOptions.couponType !== 'BRAND' && (
                  <Form.Item
                    // className="center-label"
                    label="상품명"
                    colon={false}
                    labelAlign={'left'}
                    // labelCol={{ span: 3 }}
                    // wrapperCol={{ span: 21 }}
                    style={{ marginRight: 20 }}
                  >
                    <Input
                      name="productName"
                      value={searchOptions.productName}
                      onChange={handleInputChange}
                      style={{ width: 170 }}
                    />
                  </Form.Item>
                )}
                <Form.Item
                  // className="center-label"
                  label="브랜드명"
                  colon={false}
                  labelAlign={'left'}
                  // labelCol={{ span: 3 }}
                  // wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="brandName"
                    value={searchOptions.brandName}
                    onChange={handleInputChange}
                    style={{ width: 170 }}
                  />
                </Form.Item>
              </Row>
              <Row align="middle">
                <Button
                  className={`${styles['search-button']}`}
                  onClick={onSearchProduct}
                >
                  검색
                </Button>
                <Button
                  className={`${styles['cancel-button']}`}
                  onClick={handleResetSearch}
                >
                  초기화
                </Button>
              </Row>
            </div>
            <div
              className={`${styles['coupon-target-border-wrap']} ${styles['content-padding']}`}
            >
              <div className={`${styles['coupon-target-content-wrap']}`}>
                <div className={`${styles.title2}`}>
                  검색 상품{' '}
                  <span className={`${styles['total-product-count']}`}>
                    {selectedOptions.couponType === 'BRAND'
                      ? brandList?.length
                      : productList?.length}
                  </span>
                  개 / 선택 상품{' '}
                  <span className={`${styles['select-product-count']}`}>
                    {selectedRows?.length}
                  </span>
                  개
                </div>
                <Button
                  className={`${styles['product-select-button']}`}
                  disabled={selectedRelatedProductRowKeys?.length === 0}
                  onClick={handleSelectedRowRegister}
                >
                  선택등록
                </Button>
              </div>
              <Row>
                <Col span={11}>
                  <Table
                    className={`${styles['product-list-table']}`}
                    rowSelection={{ ...rowSelection, type: 'radio' }}
                    columns={relatedMainProductColumns}
                    dataSource={productList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey="id"
                    rowClassName="coupon-table-row"
                    tableLayout={'auto'}
                    scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                    onRow={handleRowEvent}
                    pagination={false}
                  />
                </Col>
                <Col span={2} className={`${styles.col}`}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/promotion/coupon-table-arrow.png`}
                    style={{ objectFit: 'cover', width: '60%' }}
                  />
                </Col>
                <Col span={11}>
                  <Table
                    className={`${styles['product-list-table']}`}
                    rowSelection={selectedRelatedProductRowSelection}
                    columns={relatedProductColumns}
                    dataSource={relatedProductList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey="related_product_id"
                    rowClassName="coupon-table-row"
                    scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                    tableLayout={'auto'}
                    onRow={handleRelatedProductRowEvent}
                    pagination={false}
                  />
                </Col>
              </Row>
              <Divider
                className={`${styles['product-register-form-input-divider']}`}
              />
              <div className={`${styles['coupon-target-content-wrap']}`}>
                <Row align="middle">
                  <div
                    className={`${styles['coupon-target-title']}`}
                    style={{ padding: 0 }}
                  >
                    연관 상품 등록
                  </div>
                  <div className={`${styles['coupon-target-subtitle']}`}>
                    총{' '}
                    <span className={`${styles['total-product-count']}`}>
                      {selectedTargetList?.length}
                    </span>
                    개
                  </div>
                </Row>
                <Button
                  className={`${styles['product-select-cancel-button']}`}
                  disabled={selectedProductRows?.length === 0}
                  onClick={handleSelectedRowCancel}
                >
                  선택삭제
                </Button>
                <Table
                  className={`${styles['product-list-table']}`}
                  rowSelection={selectedRowSelection}
                  columns={mainAndRelatedProductColumns}
                  dataSource={selectedTargetList}
                  loading={isLoading}
                  bordered
                  size="middle"
                  rowKey="id"
                  rowClassName="coupon-table-row"
                  scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                  tableLayout={'auto'}
                  onRow={handleProductRowEvent}
                  pagination={false}
                />
              </div>
            </div>
          </>
        ) : (
          selectedOptions.couponType !== 'TOTAL' && (
            <>
              <div
                className={`${styles['coupon-target-border-wrap']}`}
                style={{ borderBottom: 0, marginTop: 20 }}
              >
                <div className={`${styles['coupon-target-title']}`}>
                  쿠폰 적용{' '}
                  {selectedOptions.couponType === 'BRAND' ? '브랜드' : '상품'}{' '}
                  등록
                </div>
              </div>
              <div
                className={`${styles['coupon-target-border-wrap']}`}
                style={{ padding: '20px 25px' }}
              >
                <Row align="middle">
                  {selectedOptions.couponType !== 'BRAND' && (
                    <Form.Item
                      // className="center-label"
                      label="상품명"
                      colon={false}
                      labelAlign={'left'}
                      // labelCol={{ span: 3 }}
                      // wrapperCol={{ span: 21 }}
                      style={{ marginRight: 20 }}
                    >
                      <Input
                        name="productName"
                        value={searchOptions.productName}
                        onChange={handleInputChange}
                        onPressEnter={onSearchProduct}
                        style={{ width: 170 }}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    // className="center-label"
                    label="브랜드명"
                    colon={false}
                    labelAlign={'left'}
                    // labelCol={{ span: 3 }}
                    // wrapperCol={{ span: 21 }}
                  >
                    <Input
                      name="brandName"
                      value={searchOptions.brandName}
                      onChange={handleInputChange}
                      onPressEnter={onSearchProduct}
                      style={{ width: 170 }}
                    />
                  </Form.Item>
                </Row>
                <Row align="middle">
                  <Button
                    className={`${styles['search-button']}`}
                    onClick={onSearchProduct}
                  >
                    검색
                  </Button>
                  <Button
                    className={`${styles['cancel-button']}`}
                    onClick={handleResetSearch}
                  >
                    초기화
                  </Button>
                </Row>
              </div>
              <div
                className={`${styles['coupon-target-border-wrap']} ${styles['content-padding']}`}
              >
                <div className={`${styles['coupon-target-content-wrap']}`}>
                  <div className={`${styles.title2}`}>
                    검색{' '}
                    {selectedOptions.couponType === 'BRAND' ? '브랜드' : '상품'}{' '}
                    <span className={`${styles['total-product-count']}`}>
                      {selectedOptions.couponType === 'BRAND'
                        ? brandList?.length
                        : productList?.length}
                    </span>
                    개 / 선택{' '}
                    {selectedOptions.couponType === 'BRAND' ? '브랜드' : '상품'}{' '}
                    <span className={`${styles['select-product-count']}`}>
                      {selectedRows?.length}
                    </span>
                    개
                  </div>
                  <Button
                    className={`${styles['product-select-button']}`}
                    disabled={selectedRows?.length === 0}
                    onClick={handleSelectedRowRegister}
                  >
                    선택등록
                  </Button>
                  {selectedOptions.couponType === 'BRAND' ? (
                    <Table
                      className={`${styles['product-list-table']}`}
                      rowSelection={rowSelection}
                      columns={brandColumns}
                      dataSource={brandList}
                      loading={isLoading}
                      bordered
                      size="middle"
                      rowKey="id"
                      rowClassName="coupon-table-row"
                      scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                      tableLayout={'auto'}
                      onRow={handleRowEvent}
                      pagination={false}
                    />
                  ) : (
                    <Table
                      className={`${styles['product-list-table']}`}
                      rowSelection={rowSelection}
                      columns={productColumns}
                      dataSource={productList}
                      loading={isLoading}
                      bordered
                      size="middle"
                      rowKey="productId"
                      rowClassName="coupon-table-row"
                      scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                      tableLayout={'auto'}
                      onRow={handleRowEvent}
                      pagination={false}
                    />
                  )}
                </div>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <div className={`${styles['coupon-target-content-wrap']}`}>
                  <Row align="middle">
                    <div
                      className={`${styles['coupon-target-title']}`}
                      style={{ padding: 0 }}
                    >
                      쿠폰 적용{' '}
                      {selectedOptions.couponType === 'BRAND'
                        ? '브랜드'
                        : '상품'}{' '}
                      등록
                    </div>
                    <div className={`${styles['coupon-target-subtitle']}`}>
                      총{' '}
                      <span className={`${styles['total-product-count']}`}>
                        {selectedTargetList?.length}
                      </span>
                      개
                    </div>
                  </Row>
                  <Button
                    className={`${styles['product-select-cancel-button']}`}
                    disabled={selectedProductRows?.length === 0}
                    onClick={handleSelectedRowCancel}
                  >
                    선택삭제
                  </Button>
                  <Table
                    className={`${styles['product-list-table']}`}
                    rowSelection={selectedRowSelection}
                    columns={
                      selectedOptions.couponType === 'BRAND'
                        ? brandColumns
                        : productColumns
                    }
                    dataSource={selectedTargetList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey={
                      selectedOptions.couponType === 'BRAND' ||
                      selectedOptions.benefitType === 'related_product'
                        ? 'id'
                        : 'productId'
                    }
                    rowClassName="coupon-table-row"
                    scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                    tableLayout={'auto'}
                    onRow={handleProductRowEvent}
                    pagination={false}
                  />
                </div>
              </div>
            </>
          )
        )}
      </div>
      <Row
        justify="center"
        align="middle"
        className={`${styles['coupon-register-button-wrap']}`}
      >
        <k
          className={`${styles.confirm}`}
          loading={isLoading}
          onClick={handleFinish}
        >
          확인
        </k>
        <Button className={`${styles.cancel}`} onClick={handleCancel}>
          취소
        </Button>
      </Row>
    </>
  )
}

export default CouponCreatePage
